// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"b5dfd691384004152fd3","293":"9cfd2fbfbf42e740227f","518":"970dda75e7bd902c9b39","779":"df9fc35056f6b7a4f156"}[chunkId] + ".js";
};